export class Cookie {

  constructor() {
    this.acceptCookiePolicyBtn = $('#accept-cookie-policy');
    this.cookiePolicy = $('.fixed-bottom.cookie-policy');
    this.footer = $('.footer-wrapper');

    if (this.cookiePolicy.length) {
      this.showCookiePolicy();
      this.watchAcceptCookiePolicy();
    }
  }

  watchAcceptCookiePolicy() {
    this.acceptCookiePolicyBtn.click(e => {
      e.preventDefault();
      this.setCookie('accepted-cookie-policy', 1);
      this.cookiePolicy.css({ bottom: this.cookiePolicy.outerHeight() * -1 });
      this.footer.addClass('animate');
    });
  }

  showCookiePolicy() {
    this.cookiePolicy.css({ bottom: this.cookiePolicy.outerHeight() * -1 });
    this.footer.css({ paddingBottom: this.cookiePolicy.outerHeight() });
    this.cookiePolicy.addClass('animate-in').css({ bottom: '0px', visibility: 'visible' });
  }

  setCookie(key, value, expiresIn = 365 * 24 * 60 * 60 * 1000) {
    var expires = new Date();
    expires.setTime(expires.getTime() + expiresIn);
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
  }

};
